import React from "react";
import { motion } from "framer-motion";
import { ChevronsRight, CornerDownRight } from "lucide-react";
import { Link } from "react-router-dom";
import banner_bg from "../../assets/images/priorhealthbanner.png";
export default function PriorHbanner() {
  return (
    <>
      <section className="relative w-full bg-[#f7f7f5] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44 md:pb-28">
        <div
          className="pointer-events-none absolute 
           top-40
       right-5 w-[30%] lg:max-w-[25%] h-auto select-none"
        >
          <img
            src={banner_bg}
            alt=""
            className="w-full h-auto object-contain object-right-top"
          />
        </div>

        <div className="mx-auto max-w-7xl px-6 lg:px-12 relative z-10 w-full">
          <div className="max-w-3xl">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-balance text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
            >
              Prior{" "}
              <span className="font-serif italic font-light text-slate-500">
                Authorization.
              </span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-lg sm:text-xl text-slate-600 max-w-2xl leading-relaxed"
            >
              Accelerating clinical workflows, eliminating manual paperwork, and
              orchestrating seamless EHR-to-payer approvals with HL7 FHIR and Camunda 8
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-base text-slate-500 flex flex-row gap-1 items-center leading-relaxed"
            >
              <Link to="/">Home</Link> <ChevronsRight size={20} />
              <span className="hover:text-slate-950 transition-colors">
                Industries
              </span>{" "}
              <ChevronsRight size={20} />
              <span className="text-slate-950 font-medium">Prior Authorization</span>
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="mt-7 pt-6 border-t border-slate-300/80 flex items-center gap-3 text-xs font-mono text-slate-500 tracking-widest uppercase"
            >
              <CornerDownRight size={14} className="text-slate-950" />
              <span>Scroll to explore clinical architecture &amp; standards</span>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}